<template>
  <div id="user_trains_pay_outer">
    <div style="font-weight: bold;font-size: 1.3rem;text-align: center;">
      支付培训费<br>
      <span style="font-size: 1rem">(3/3)</span>
    </div>

    <div class="content" >
      <div style="font-weight: bold;font-size: 1.5rem;">微信支付</div>
      <wechat-pay-card v-if="payData != null && payData != undefined" style="margin-top: 20px;"
                       v-bind:pay-model="payData"
                       v-on:payClicked="payButtonClicked" ></wechat-pay-card>
      <div v-else style="margin-top: 20px;height: 200px;"></div>

      <div style="color: #fc1a34;margin-top: 15px;">支付金额：{{itemData.amount + '元'}}</div>

      <div v-if="!isWeixin()" style="margin-top: 10px;color: #666;">请使用微信进行扫码支付</div>
    </div>

  </div>
</template>

<script>
import WechatPayCard from "../common/WechatPayCard";

export default {
  name: "UserTrainsPays",
  props: [
    'payData','itemData'
  ],
  components: {
    WechatPayCard,
  },
  data() {
    return {

    }
  },

  methods: {
    payButtonClicked() {
      this.$emit('payClicked');
    }
  }
}
</script>

<style scoped>
  #user_trains_pay_outer {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }

  #user_trains_pay_outer .content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    padding: 30px 25px;
  }

</style>



// WEBPACK FOOTER //
// src/components/course/UserTrainsPays.vue